import React, { useState, useEffect } from 'react';
import s from './Profile.module.css';
import { deleteAccount } from '../../../../shared/api/authApi';
import { useAppDispatch } from '../../../../store/store';
import DeleteAccountModal from './DeleteAccountModal';
import { toast } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import ConnectedSocialAccount from './ConnectedSocialAccount';
import PersonalInformationForm from './PersonalInformationForm';
import AvatarSection from './AvatarSection';

const Profile = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [isLoadingDelete, setIsLoadingDelete] = useState(false);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const error = searchParams.get('error');

        if (error === 'social_provider_linked') {
            toast.error('This social media account is already linked to another user account');

            searchParams.delete('error');
            const newUrl = searchParams.toString()
                ? `${location.pathname}?${searchParams.toString()}${location.hash}`
                : `${location.pathname}${location.hash}`;
            navigate(newUrl, { replace: true });
        }
    }, [location.search, location.pathname, location.hash, navigate]);

    const handleDeleteAccountConfirm = async () => {
        try {
            setIsLoadingDelete(true);
            await dispatch(deleteAccount()).unwrap();
            localStorage.removeItem('authToken');
            dispatch({ type: 'RESET_APP' });
            navigate('/login');
            toast.success('Your account has been deleted');
        } catch (error) {
            console.error('Failed to delete account:', error);
            toast.error('Failed to delete account');
        } finally {
            setIsLoadingDelete(false);
        }
    };

    return (
        <div className={s.profile}>
            <h2 className={s.sectionTitle}>Personal information</h2>

            <AvatarSection />
            <PersonalInformationForm />
            <ConnectedSocialAccount />

            <DeleteAccountModal
                isOpen={deleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                onConfirm={handleDeleteAccountConfirm}
                isLoading={isLoadingDelete}
            />

            <button className={s.deleteBtn} onClick={() => setDeleteModalOpen(true)}>
                Delete account
            </button>
        </div>
    );
};

export default Profile;
